import React, { useEffect, useState } from 'react';

const Scroller = ({ direction = "left", speed = "fast", children }) => {
  const [isReducedMotion, setIsReducedMotion] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setIsReducedMotion(mediaQuery.matches);

    if (!mediaQuery.matches) {
      setIsAnimated(true);
    }

    mediaQuery.addEventListener("change", (e) => {
      setIsReducedMotion(e.matches);
      if (!e.matches) {
        setIsAnimated(true);
      } else {
        setIsAnimated(false);
      }
    });

    return () => mediaQuery.removeEventListener("change", () => {});
  }, []);

  const animationDuration = speed === "fast" ? "180s" : "180s";
  const animationDirection = direction === "right" ? "reverse" : "forwards";

  return (
    <div
      className="scroller"
      data-animated={isAnimated ? "true" : "false"}
      style={{
        width: "100%",  // Full width of the parent container (or viewport)
        maxWidth: "100%",  // Remove max-width limit
        overflow: isReducedMotion ? "visible" : "hidden",
        mask: isAnimated ? "linear-gradient(90deg, transparent, white 20%, white 80%, transparent)" : "none",
        WebkitMask: isAnimated ? "linear-gradient(90deg, transparent, white 20%, white 80%, transparent)" : "none",
      }}
    >
      <div
        className="scroller__inner"
        style={{
          display: "flex",
          gap: "1rem",
          flexWrap: "nowrap",  // Ensure items don't wrap
          animation: isAnimated ? `scroll ${animationDuration} ${animationDirection} linear infinite` : "none",
        }}
      >
        {React.Children.map(children, (child) => (
          <div>{child}</div>
        ))}
        {!isReducedMotion &&
          React.Children.map(children, (child) => (
            <div aria-hidden="true">{child}</div>
          ))}
      </div>
    </div>
  );
};

export default Scroller;
